import React from 'react';
import { supabase } from '../lib/supabaseClient';

export type InboxLiveEvent = 'INSERT' | 'UPDATE';
export type InboxLiveRow = Record<string, unknown>;

type UseInboxLiveEmailsOptions = {
  instanceId: string | null;
  accountId: string | number | null;
  onRowChange: (event: InboxLiveEvent, row: InboxLiveRow) => void;
};

export function useInboxLiveEmails({ instanceId, accountId, onRowChange }: UseInboxLiveEmailsOptions) {
  const onRowChangeRef = React.useRef(onRowChange);
  onRowChangeRef.current = onRowChange;

  React.useEffect(() => {
    if (!instanceId || accountId == null) return;
    const accountFilter = String(accountId);

    const channel = supabase
      .channel(`inbox_emails:${instanceId}:${accountFilter}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'inbox_emails',
          filter: `account_id=eq.${accountFilter}`,
        },
        (payload) => {
          onRowChangeRef.current('INSERT', (payload.new ?? {}) as InboxLiveRow);
        },
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'inbox_emails',
          filter: `account_id=eq.${accountFilter}`,
        },
        (payload) => {
          onRowChangeRef.current('UPDATE', (payload.new ?? {}) as InboxLiveRow);
        },
      )
      .subscribe();

    return () => {
      void supabase.removeChannel(channel);
    };
  }, [instanceId, accountId]);
}
